export enum StatusCodeEnum {
  BadRequest = 400,
  Conflict = 409,
  Forbidden = 403,
  Gone = 410,
  InternalServerError = 500,
  NotFound = 404,
  Ok = 200,
  PreconditionRequired = 428,
  TooManyRequests = 429,
  Unauthorized = 401,
  UnprocessableEntity = 422,
}
